import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const GuestLayout = () => {

    const isAuthenticated:string = useSelector((state:any) => state.auth.isAuthenticated);
    const initialUrl:string = useSelector((state:any) => state.auth.initialUrl);
    const navigate = useNavigate();

    useEffect(() => {
        console.log(isAuthenticated)
        if(isAuthenticated){
            navigate(initialUrl);
        }

    }, [isAuthenticated, navigate, initialUrl])

    return (
        <>
        <Outlet/>
        </>
    )
}

export default GuestLayout;